import { httpsCallable, httpsCallableFromURL } from 'firebase/functions';
import { functions } from '../config/firebase';

/** Must stay below Cloud Function timeoutSeconds; default SDK timeout is ~70s and causes deadline-exceeded on large imports. */
const EXTRACT_FUND_INVESTORS_IMPORT_TIMEOUT_MS = 520_000;

const callableOptions = { timeout: EXTRACT_FUND_INVESTORS_IMPORT_TIMEOUT_MS };

function getExtractFundInvestorsImportCallable() {
  if (import.meta.env.DEV && typeof window !== 'undefined') {
    const url = `${window.location.origin}/__fb_functions/extractFundInvestorsImport`;
    return httpsCallableFromURL(functions, url, callableOptions);
  }
  return httpsCallable(functions, 'extractFundInvestorsImport', callableOptions);
}

/**
 * @param {string} fileBase64
 * @param {string} fileName
 * @param {'fr'|'en'} locale
 * @returns {Promise<{ investors: Array<Record<string, unknown>> }>}
 */
export async function extractFundInvestorsImport(fileBase64, fileName, locale) {
  const fn = getExtractFundInvestorsImportCallable();
  const res = await fn({
    fileBase64,
    fileName,
    locale: locale === 'fr' ? 'fr' : 'en',
  });
  return res.data;
}
